export default __webpack_public_path__ + "c4958520e0c5610f4f0d8631c0e5101a.svg";